// BlogCard.jsx
import React from 'react';
import '../assets/Blog.css';
import slogo from '../assets/imgs/samriddhi_logo_flower.webp';

const Blog = () => {
    return (
        <div className="blog-card">
            <div className="blog-header">
                <span className="blog-category">Blog - By Samriddhi Group | Builder & Developers</span>
                <span className="blog-date">Posted 05 July 2025, 09:30am</span>
            </div>
            <h1 className="blog-title">🌿 The Panch Tatva -Behind Our Project Design.</h1>

            <div className="blog-image-section">
                <img
                    src={slogo} loading="lazy"
                    alt="Blog Visual"
                    className="blog-image"
                />
            </div>

            <div className="blog-quote-section">
                <div className="quote-mark">❝</div>
                <div className="quote-text">
                    At Samriddhi Group, we don’t just build projects — we craft timeless legacies rooted in the soul of nature. One of the core philosophies that guide our vision is the ancient Indian concept of <strong> Panch Tatva </strong> – the five elements of nature: <strong>  Earth (Prithvi), Water (Jal), Fire (Agni), Air (Vayu), and Space (Akash).</strong>
                </div>
            </div>

            <div className="blog-content">
                <p>
                    These elements are not just symbolic. They are <i>
                        integrated into every decision we make — from land selection to layout design, from amenities to aesthetics.
                    </i>
                </p>

                <br></br>

                <p>

                    <h2> 🌍 1. Prithvi (Earth): The Foundation of Stability </h2>

                    We choose virgin landscapes rich in natural soil, fertility, and terrain — be it the red soils of Konkan (Kokan Samriddhi) or the lush plateaus near Lonavala (Lonavalley). Every plot is connected to the grounding energy of nature, offering stability, abundance, and long-term growth.
                </p>

                <br></br>

                <p> <h2>  💧 2. Jal (Water): The Essence of Life </h2>
                    <br></br>
                    Our signature projects like Waterscape and Blue Horizon are designed around water bodies — rivers, lakes, or dams. Water not only enhances beauty but symbolizes emotional flow, prosperity, and rejuvenation. We ensure water security, sustainability, and harmony with the surrounding ecosystem.</p>

                <br></br>

                <p>
                    <h2>🔥 3. Agni (Fire): The Energy of Transformation  </h2>
                    Fire symbolizes vision, ambition, and vitality. We reflect this through modern amenities like wellness resorts, clubhouses, and recreational zones that energize lifestyles. Our developments spark transformation — from passive landholding to active living and generational legacy.
                </p>

                <br></br>

                <p><h2>  🌬️ 4. Vayu (Air): The Breath of Freedom </h2>
                    Our locations are handpicked for their fresh air quality, open skies, and clean breeze — far from urban pollution. Whether it’s the hilly winds of Mahabaleshwar or coastal air of Ratnagiri, our environments invite well-being, clarity, and peace.</p>

                <br></br>

                <p> <h2> 🌌 5. Akash (Space): The Canvas of Possibilities  </h2>
                    Every Samriddhi project is intentionally designed with space, openness, and vision. Be it 10,000+ sq.ft plots, sky-view bungalows, or tree-laden orchards — we offer room to grow, breathe, and build your own legacy under an open sky.</p>

                <br></br>

                <p> <h2> 🌱 Beyond Construction — It’s a Spiritual Blueprint  </h2>
                    In a world chasing concrete, we return to conscious construction — inspired by timeless Indian wisdom. Our Panch Tatva approach ensures that every plot, every tree, and every amenity contributes to physical comfort, emotional wellness, and spiritual connection.</p>

                <br></br>

                <p>Because we believe:</p>

                <h3>Nature builds first. We just follow its blueprint.</h3>


            </div>
        </div>
    );
};

export default Blog;
